import { createAction } from "@reduxjs/toolkit";
import { ITemplateDocumentItem } from "../../models/template";
import { StoreState, StoreStateDontLoad } from "../storeState";
import {
  ITemplateDocumentListFilter,
  TemplateDocumentListTypes,
} from "./types";

export const templateDocumentListFetchRequest = createAction<
  StoreStateDontLoad,
  TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_FETCH_REQUEST
>(TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_FETCH_REQUEST);

export const templateDocumentListFetchSuccess = createAction<
  {
    data: ITemplateDocumentItem[];
    newCountState: StoreStateDontLoad;
    newCount: number;
  },
  TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_FETCH_SUCCESS
>(TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_FETCH_SUCCESS);

export const templateDocumentListFetchError = createAction<
  boolean,
  TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_FETCH_ERROR
>(TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_FETCH_ERROR);

export const templateDocumentListCountRequest = createAction<
  void,
  TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_COUNT_REQUEST
>(TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_COUNT_REQUEST);

export const templateDocumentListCountSuccess = createAction<
  number,
  TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_COUNT_SUCCESS
>(TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_COUNT_SUCCESS);

export const templateDocumentListCountError = createAction<
  boolean,
  TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_COUNT_ERROR
>(TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_COUNT_ERROR);

export const templateDocumentListChangeOrder = createAction<
  { orderBy: string; orderDesc: boolean },
  TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_CHANGE_ORDER
>(TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_CHANGE_ORDER);

export const templateDocumentListChangePage = createAction<
  number,
  TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_CHANGE_PAGE
>(TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_CHANGE_PAGE);

export const templateDocumentListChangeFilter = createAction<
  ITemplateDocumentListFilter,
  TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_CHANGE_FILTER
>(TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_CHANGE_FILTER);

export const templateDocumentListReset = createAction<
  void,
  TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_RESET
>(TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_RESET);

export const templateDocumentListLoadAction = createAction<
  { newState: StoreState; newCountState: StoreStateDontLoad },
  TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_LOAD
>(TemplateDocumentListTypes.TEMPLATE_DOCUMENT_LIST_LOAD);
